export default "__VITE_ASSET__Dc3P6Nai__"